import React from 'react'
import {Link} from 'react-router-dom'

const Redirecting = ({path, title, description, icon}) => (
  <section className="hero is-fullheight">
    <div className="hero-body">
      <div className="container tw:text-center">
        <div className="columns is-tablet is-centered">
          <div className="column is-one-third">
            <h1 className="title is-4">{title || 'Redirecting'}</h1>
            <span className="icon is-large">
              <i className={`fa-3x fa-solid ${icon || 'fa-random'}`} />
            </span>
            <p className="tw:mt-4">{description || 'You are being redirected.'}</p>
            <p className="tw:mt-4">
              <Link className="button is-primary" to={path}>
                Redirect now
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Redirecting
